import { render, staticRenderFns } from "./Club_activities.vue?vue&type=template&id=f38b984a&scoped=true"
import script from "./Club_activities.vue?vue&type=script&lang=js"
export * from "./Club_activities.vue?vue&type=script&lang=js"
import style0 from "./Club_activities.vue?vue&type=style&index=0&id=f38b984a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b984a",
  null
  
)

export default component.exports